<div class="card-body position-relative overflow-hidden">
  <div class="font-size-36 font-weight-bold text-dark mb-n2">{{onlineAdapters}}</div>
  <div class="text-uppercase">Online Adapters</div>
  <div class="chartContainer">
  </div>
</div>